<template>
    <div class="library-published-status-filter" data-testid="library-published-status-filter">
        <CollapsibleWidget>
            <template #name>Publishing Status</template>

            <CheckboxGroup :model-value="[creativeLibraryFiltersStore.publishedStatus]">
                <template v-for="item in mainFilters" :key="item.value">
                    <Checkbox
                        :label="item.value"
                        @click.stop.prevent="creativeLibraryFiltersStore.publishedStatus = item.value"
                    >
                        {{ item.label }}
                    </Checkbox>
                    <div v-if="item.submenu && item.showSubmenu" class="library-published-status-filter__sub-group">
                        <Checkbox
                            v-for="submenu in item.submenu"
                            :key="submenu.value"
                            :label="submenu.value"
                            @click.stop.prevent="creativeLibraryFiltersStore.publishedStatus = submenu.value"
                        >
                            {{ submenu.label }}
                        </Checkbox>
                    </div>
                </template>
            </CheckboxGroup>
        </CollapsibleWidget>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { PLATFORM } from "shared-utils/enums/exports";

import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { PublishedStatusFilter } from "@/enums/filters";
import { PlatformLabel } from "@/enums/platforms";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";

const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();

const mainFilters = computed(() => [
    {
        value: PublishedStatusFilter.All,
        label: "All"
    },
    {
        value: PublishedStatusFilter.Published,
        label: "Published",
        submenu: [
            {
                value: PublishedStatusFilter.PublishedToDoubleClick,
                label: PlatformLabel[PLATFORM.DOUBLECLICK]
            },
            {
                value: PublishedStatusFilter.PublishedToOpenDC,
                label: PlatformLabel[PLATFORM.OPENDC]
            }
        ],
        showSubmenu:
            creativeLibraryFiltersStore.publishedStatus === PublishedStatusFilter.Published ||
            creativeLibraryFiltersStore.publishedStatus === PublishedStatusFilter.PublishedToDoubleClick ||
            creativeLibraryFiltersStore.publishedStatus === PublishedStatusFilter.PublishedToOpenDC
    },
    {
        value: PublishedStatusFilter.NotPublished,
        label: "Not published",
        submenu: [
            {
                value: PublishedStatusFilter.NotPublishedToDoubleClick,
                label: PlatformLabel[PLATFORM.DOUBLECLICK]
            },
            {
                value: PublishedStatusFilter.NotPublishedToOpenDC,
                label: PlatformLabel[PLATFORM.OPENDC]
            }
        ],
        showSubmenu:
            creativeLibraryFiltersStore.publishedStatus === PublishedStatusFilter.NotPublished ||
            creativeLibraryFiltersStore.publishedStatus === PublishedStatusFilter.NotPublishedToDoubleClick ||
            creativeLibraryFiltersStore.publishedStatus === PublishedStatusFilter.NotPublishedToOpenDC
    }
]);
</script>

<style lang="scss">
@use "@style/variables" as *;
.library-published-status-filter__sub-group {
    margin: 0 0 $spacing-smaller $spacing;
    padding: $spacing-smaller 0;
}
</style>
